'use strict';

export const sep='/';
export const validate_account = 'Non-Training Account Selected, Select Training Account Only!';
export const validate_aat = 'Account Access Token not mapped for this account, Contact Administrator!';
export const account = 'Account';
export const trainer_console = 'Trainer Console';
export const company_name = 'CONNECT';
export const help_link = 'https://aveva-dev.zoominsoftware.io/category/aveva-connect-get-started';
export const home_link = './training/home';
export const trainingList_columns = ['select', 'account_name', 'first_name', 'last_name', 'email_id', 'folder_name', 'group_name', 'status', 'cds_status', 'stream_status', 'menu'];
export const services_columns = ['select', 'service_name'];
export const multiple_students = 'Multiple Students selected for Single Account';
export const assignProcess_time = 'Assign Process takes ~1min for each student';
export const setupProcess_time = 'Setup Process takes between ~3-5mins for each student';
export const cleanupProcess_time = 'Cleanup Process takes between ~2-3mins for each student';
export const studentDelete_success = 'Student Deleted Successfully !';
export const studentDelete_fail = 'Student Delete Failed !';
export const clientCredentials_notFound = 'Client Id and Secret not available for Account';
export const student_inuse = 'Student already In-Use for this Account(s)';
export const students_inuse = 'Students should be of "Assigned", "In Use" or "Error" State for Cleanup Training';
export const students_assigned = 'Students should be of only "Assigned" State for Setup Training';
export const class_updated = 'Class Updated';
export const class_update_failed = 'Class Update failed !';
export const class_withStudents = 'Class with students cannot be deleted, remove students from class';
export const class_deleted = 'Class Deleted';
export const classCreate_success = 'Class Created Successfully !';
export const classCreate_fail = 'Class Create Failed !';
export const className_exists = 'Class Name already exists !';
export const student = 'Student';
export const availabilities_columns = ['account_name', 'class_name', 'first_name', 'last_name', 'email_id', 'folder_name', 'group_name'];
export const exportFile_title = 'export-excel';
export const exportFile_dateFormat = 'dd_MM_yyyy_hh_mm_ss';
export const exportFile_name = 'Availabilities';
export const exportFile_sheetName = 'students';
export const exportNamespacesFile_name = 'Namespaces';
export const exportNamespacesFile_sheetName = 'namespaces';
export const no_secret = 'No Secret found for selected Client Id !';
export const assignments_columns = ['account_name', 'client_id', 'client_secret', 'menu'];
export const assignment_success = 'Assigned successfully !';
export const assignment_failed = 'Assigning failed !';
export const select_account = 'Please Select Account';
export const studentCreate_success = 'Student created successfully !';
export const studentCreate_fail = 'Student create failed !';
export const studentFolderGroupNameValidation = 'Student cannot have same Folder and Group Name !';
export const accountAdd_success = 'Account added successfully !';
export const accountAdd_fail = 'Account add failed !';
export const accountUpdate_success = 'Account updated successfully !';
export const accountUpdate_fail = 'Account update failed !';
export const accounts_columns = ['account_name', 'account_id', 'menu'];
export const importFileError = 'Invalid import file, confirm sheet name is "students" and valid data';
export const imports_columns = ['filename', 'date', 'students_processed', 'status', 'report'];
export const unassigned_students = 'Students to be of State "Unassigned" only !';
export const cleanupRequest_succeeded = 'Cleanup Request succeeded !';
export const cleanupRequest_failed = 'Cleanup Request failed !';
export const select_dataset = 'Select Dataset';
export const dataset_columns = ['name', 'description', 'file', 'backfillDays', 'menu'];
export const datasetAdd_success = 'Dataset Added successfully !';
export const datasetUpdate_success = 'Dataset Updated successfully !';
export const datasetAdd_fail = 'Dataset Adding failed !';
export const datasetUpdate_fail = 'Dataset Update failed !';
export const students_stream_on = 'Students with already Streaming "On" selected';
export const students_stream_off = 'Students with already Streaming "Off" selected';
export const cds_inuse_dataset_changed = 'Dataset cannot be changed, student(s) has "Cds Status" "In Use" !';
export const reset_studentStatus_success = 'Student Status Reset completed successfully !';
export const reset_studentStatus_failed = 'Student Status Reset failed !';
export const resend_invite_success = 'Invite Resent Successfully !';
export const resend_invite_failed = 'Failed to Resend Invite !';
export const student_updated_successfully = 'Student updated successfully !';
export const student_update_failed = 'Failed to update Student !';
export const student_update_title = 'Update Student';
export const student_update = 'Are you sure you want to update student';
export const student_update_validation = 'Student is in Unassigned/Base/Error State, better to delete and add new student !.';
export const reset_backfill_date_success = 'Reset of backfill date for students selected completed successfully !';
export const reset_backfill_date_failed = 'Reset of backfill date for students selected failed !';
export const reset_backfill_date_validation = 'Student is in Unassigned/Base/Error State, Still isnt part of Account !.';
export const memberships_columns = ['members', 'menu'];
export const membership_title = 'Remove Membership from Account';
export const member_added_successfully = 'Member added to account successfully !';
export const member_add_failed = 'adding Member to account failed !';
export const member_removed_successfully = 'Member removed from account successfully !';
export const member_remove_failed = 'removing Member from account failed !';
export const aat = 'Account Access Token';
export const aat_update = 'Are you sure, you want to update Account Access Token for the account ?';
export const aat_update_success = 'Account Access token updated successfully !';
export const aat_update_fail = 'updating Account Access token failed !';
export const configuration_columns = ['key', 'value', 'menu'];
export const configuration_update = 'Update Environment Variable';
export const configuration_update_success = 'Environment Variable updated successfully !';
export const configuration_update_failed = 'Environment Variable update failed !';
export const update = 'Update';
export const datasetDelete_success = 'Dataset Deleted successfully !';
export const datasetDelete_fail = 'Dataset Delete Failed !';
export const healthstats_columns = ['class_name', 'account_name', 'first_name', 'last_name', 'email_id', 'folder_name', 'group_name', 'service', 'health'];
export const students_duplicates = 'Students with same account cannot have same Folder/Group Name';
export const folders_limit_exceeded = 'An account can have only Folders of Count';
export const UNASSIGNED = 'Unassigned';
export const ASSIGNED = 'Assigned';
export const ASSIGNING = 'Assigning...';
export const CREATING = 'Creating...';
export const IN_USE = 'In Use';
export const ERROR = 'Error';
export const CLEANING = 'Cleaning...';
export const ERROR_ASSIGN = 'ErrorA';
export const STREAMING = 'Streaming...';
export const ON = 'On';
export const OFF = 'Off';
export const AUTHORIZATION = 'Authorization';
export const BEARER = 'Bearer ';
export const TC = 'tc';
export const tcrequests = 'tcrequests/*';
export const trainingadmin = 'trainingadmin';
export const trainer = 'trainer';
export const viewer = 'viewer';
export const namespace_columns = ['account_id', 'account_name', 'namespace_id', 'namespace_name', 'region', 'state'];
export const hardRefresh_namespace = 'Namespaces will be re-evaluated, please wait for sometime !';
export const hardRefresh_folders = 'Active Folders will be re-evaluated, please wait for sometime !';
export const folderList_columns = ['select', 'account_name', 'folder_name', 'services'];
export const cleanupFolders = 'Selected Folder(s) will be Deleted, Any Active Student(s) using the Folder(s) will be Skipped';
export const datasetFile_required = 'Dataset File is required !';
export const dataset_cds_select = 'Dataset cannot be "None" with "DataHub" services Enabled !';

export const GROUP = 'Group';
export const FOLDER = 'Folder';
export const FOLDERS = 'Folders';

export const POLICIES = 'policies';
export const USER_EMAIL = 'user_email';
export const ACCOUNT_ID = 'account_id';
export const CLASS_NAME = 'class_name';
export const TRUE = 'True';

export const ACCOUNTS = 'Accounts';
export const ASSIGNMENTS = 'Assignments';
export const CDS = 'Cds';
export const CLASSES = 'Classes';
export const CONFIGURATIONS = 'Configurations';
export const CONNECT = 'Connect';
export const DATASETS = 'Datasets';
export const IMPORTS = 'Imports';
export const MEMBERSHIPS = 'Memberships';
export const STUDENTS = 'Students';

export const GET_ACCOUNTS = 'GetAccounts';
export const GET_ACCOUNTS_ALL = 'GetAccountsAll';
export const GET_ACCOUNTS_AVAILABLE = 'GetAccountsAvailable';
export const ADD_OR_UPDATE = 'AddOrUpdate';
export const GET_AAT = 'GetAAT';
export const IS_ACCOUNT_USER_ACCESS = 'isAccountUserAccess';
export const IS_ACCOUNT_ACCESS_TOKEN = 'IsAccountAccessToken';
export const ACCOUNTS_IN_USE = 'AccountsInUse';
export const ACCOUNTS_STUDENTS_IN_USE = 'AccountsStudentsInUse';
export const ACCOUNTS_STUDENTS_ASSIGN = 'AccountsStudentsAssign';
export const ACCOUNTS_FOLDERS_IN_USE = 'AccountsFoldersInUse';
export const UPDATE_AAT = 'UpdateAAT';

export const GET_ASSIGNMENTS = 'GetAssignments';
export const GET_ASSIGNMENT_GUID = 'GetAssignmentGuid';
export const GET_ASSIGNMENT = 'GetAssignment';
export const GET_ASSIGNMENTS_INVALID = 'GetAssignmentsInvalid';
export const UPDATE_ASSIGNMENT = 'UpdateAssignment';

export const SETUP = 'Setup';
export const RUN = 'Run';
export const STOP = 'Stop';
export const CLEANUP = 'Cleanup';

export const GET_CLASSES = 'GetClasses';
export const GET_CLASS = 'GetClass';
export const CREATE_CLASS = 'CreateClass';
export const IS_CLASS_EXISTS = 'IsClassExists';
export const IS_CLASS_EXISTS_DATASET = 'IsClassExistsDataset';
export const UPDATE_CLASS = 'UpdateClass';
export const DELETE_CLASS = 'DeleteClass';

export const GET_ENVVARIABLES = 'GetEnvVariables';
export const GET_ENVVARIABLE = 'GetEnvVariable';
export const GET_CREATESERVICES = 'GetCreateServices';
export const UPDATE_ENVVARIABLES = 'UpdateEnvVariables';

export const GET_ACCOUNTS_BY_USER = 'GetAccountsByUser';
export const ASSIGN_RESOURCES = 'AssignResources';
export const CREATE_RESOURCES = 'CreateResources';
export const CLEANUP_RESOURCES = 'CleanupResources';
export const UPDATE_STUDENT = 'UpdateStudent';
export const RESEND_INVITE = 'ResendInvite';
export const FORCE_DELETE = 'ForceDelete';

export const GET_DATASETS = 'GetDatasets';
export const DELETE_DATASET = 'DeleteDataset';
export const DATASET_DELETE = 'DatasetDelete';
export const DATASET_UPLOAD = 'DatasetUpload';
export const DATASET_DOWNLOAD = 'DatasetDownload';

export const CREATE_IMPORT = 'CreateImport';
export const GET_IMPORT = 'GetImport';
export const QUERY_IMPORTS = 'QueryImports';

export const GET_MEMBERSHIPS = 'GetMemberships';
export const ADD_MEMBERSHIP = 'AddMembership';
export const REMOVE_MEMBERSHIP = 'RemoveMembership';

export const GET_STUDENTS = 'GetStudents';
export const GET_STUDENT_BY_ID = 'GetStudentsById';
export const GET_STUDENTS_BY_CLASS_ID = 'GetStudentsByClassId';
export const GET_STUDENTS_CDS_IN_USE_BY_CLASS_ID = 'GetStudentsCdsInUseByClassId';
export const GET_STUDENTS_COUNT_BY_CLASS_ID = 'GetStudentsCountByClassId';
export const IS_STUDENT_IN_USE = 'IsStudentInUse';
export const CREATE_STUDENT = 'CreateStudent';
export const UPDATESTUDENT = 'UpdateStudent';
export const DELETESTUDENT = 'DeleteStudent';
export const RESETSTUDENT = 'ResetStudent';
export const UPDATE_CDS_STATUS = 'UpdateCdsStatus';
export const RESETBACKFILLDATE = 'ResetBackfillDate';

export const CLASS_ID = 'class_id';
export const RESOURCELIMIT = 'ResourceLimit';
export const DELETE_WARN = 'Are you sure you want to delete'; 
export const DELETE = 'Delete';
export const DOWNLOAD = 'Download';
export const UPDATE_WARN_ENV_VARIBLES = 'Are you sure, you want to update environment variable';
export const DOWNLOAD_DATASET = 'Download dataset';
export const DOWNLOAD_DATASET_CONFIRM = 'Are you sure you want to download';
export const MEMBERSHIP_ALREADYEXISTS = 'Membership already exists';
export const CLASS_LIMIT_REACHED = 'classLimitReached';
export const DATASET_MAPPEDWITHCLASS = 'Dataset {0} is mapped with class. Delete Class and retry deleting the dataset.';
export const RESET_CONFIRM = 'Are you sure you want to reset status of';
export const RESET_STUDENT = 'Reset Student Status';
export const RESET_BACKFILL_DATE = 'Reset Backfill Date';
export const RESET_BACKFILL_CONFIRM = 'Are you sure, you want to reset backfill date of students selected ?';
export const aiCloudRole = 'ai.cloud.role';
export const appName = 'trainerConsole-web';
export const ACTIVE = 'Active';
